import { configApi } from 'api/configApi';
import axios, { AxiosInstance } from 'axios';
import { SharepointEntities } from 'utils/enums';

export const getHelpSectionFromConfigApi = async (
  http: AxiosInstance | null,
  configName: string
) => {
  const response = await configApi(http)?.getConfigByName(configName);

  return response?.data.data;
};

export const getHelpSectionFromSharepointApi = async (env: any, entity: SharepointEntities) => {
  const response = await axios.get<{ value: any[] }>(
    `${env.settings.apiBaseURL}/mock/list?entity=${entity}`,
    {
      headers: {
        'Ocp-Apim-Subscription-Key': env.settings.ocpApimKey,
      },
    }
  );

  return response?.data?.value;
};
